import { render, staticRenderFns } from "./teacher_class.vue?vue&type=template&id=76b38fc4&"
import script from "./teacher_class.vue?vue&type=script&lang=js&"
export * from "./teacher_class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports